import { BiWrench } from 'react-icons/bi';

import { StatTile } from '@/components/StatTile/StatTile';
import { BaseWidget } from '@/components/Widget/BaseWidget';
import { DUE_SOON_ROUTE, OVERDUE_ROUTE } from '@pages/Maintain/constants';
import { useMaintenanceDueCounts } from '@pages/Maintain/maintain-queue.queries';

import styles from './MaintenanceTasksWidget.module.scss';

export const MaintenanceTasksWidget = () => {
  const { overdueCount, dueSoonCount, isPending } = useMaintenanceDueCounts();

  return (
    <BaseWidget headerTitle="Maintenance Tasks" headerIcon={<BiWrench />}>
      <div className={styles.tiles}>
        <StatTile
          label="Overdue"
          value={isPending ? undefined : overdueCount}
          sublabel="Maintenance Tasks"
          icon={<span className={`${styles.dot} ${styles.dotDanger}`} aria-hidden="true" />}
          to={OVERDUE_ROUTE}
        />
        <StatTile
          label="Due Soon"
          value={isPending ? undefined : dueSoonCount}
          sublabel="Maintenance Tasks"
          icon={<span className={`${styles.dot} ${styles.dotWarn}`} aria-hidden="true" />}
          to={DUE_SOON_ROUTE}
        />
      </div>
    </BaseWidget>
  );
};

export default MaintenanceTasksWidget;
